import { CaseSearchResultModel } from "../Types";

export const CaseSearchModel: CaseSearchResultModel = {
  data: [],
  isError: false,
  isLoading: false,
};
